///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createReducer, on } from '@ngrx/store';
import { EulaState, initialState } from './eula.state';
import { getEula, setEula, uploadEula } from './eula.actions';

export const reducer = createReducer(
    initialState,

    on(getEula, uploadEula, (state: EulaState): EulaState => {
        return {
            ...state,
            isLoading: true
        };
    }),

    on(setEula, (state: EulaState, action): EulaState => {
        return {
            ...state,
            isLoading: false,
            eula: action.eula
        };
    })
);
